/*LIBRARY*/
import { connect } from "react-redux";

/*COMPONENT*/

/*REDUX*/
import { set_value_properties } from "../../App/actions/propertiesActions";
import TableFormula from "../common_field/TableFormula";
import useLanguage from "../common_hooks/useLanguage";

/*PICTURE*/

/*FUNCTION*/

/*DATA*/
// import dict from "../../Data/dict.json";

/*CONST*/

const SET_TF = ({
  //variable
  // auth,
  // layer,
  properties,

  //function
  set_value_properties,
}) => {
  // hooks
  const { language } = useLanguage();

  //state & ref

  //global props
  const { field_editable } = properties;
  const { table_formula } = field_editable || {};

  //functions
  const set_table_formula = (table_formula) => {
    set_value_properties({
      key: "field_editable",
      value: {
        ...field_editable,
        table_formula: table_formula,
      },
    });

  };

  return (
    <main>
      <h1 className="text_bold margin_bottom">Pengaturan Tabel Formula</h1>

      <div className="container background_grey_light outline_grey paddingTop_10 marginBottom_15">
        <TableFormula
          language={language}
          table_formula={table_formula}
          set_table_formula={set_table_formula}
        />
      </div>

    </main>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  layer: state.layer,
  properties: state.properties,
});

export default connect(mapStateToProps, { set_value_properties })(SET_TF);
